<template>
  <div class="box-table" :style="{height: tableHeight+'px'}">
    <el-table
      ref="onlineTableRefs"
      :data="online"
      tooltip-effect="dark"
      :max-height="tableHeight"
      :header-cell-style="tableHeader"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick"
      v-loading="loadingTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      border
    >
      <el-table-column type="selection" :selectable="selectableFun"></el-table-column>
      <el-table-column label="产品编号" width="95px">
        <template slot-scope="scope">
          <span class="product-bold">{{ scope.row.productCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="productClassName" label="产品品类" width="95px" show-overflow-tooltip></el-table-column>
      <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
      <!-- <el-table-column prop="bgName" label="系列组" width="95px"></el-table-column> -->
      <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" label="产品名称" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="line-limit-length">{{scope.row.productName}}</div>
        </template>
      </el-table-column>
      <el-table-column label="型号名称" show-overflow-tooltip>
        <template slot-scope="scope">
          <div
            class="approval line-limit-length"
            @click="onProductDetail(scope.row)"
          >{{scope.row.productModel}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="productModelNick" label="型号别称" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productOrderNum" label="订货号" width="95px" show-overflow-tooltip>
        <template slot-scope="scope">
          <div
            class="approval line-limit-length"
            @click="onProductDetail(scope.row)"
          >{{scope.row.productOrderNum}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="productPrice" label="产品面价"></el-table-column>
      <el-table-column prop="productUnit" label="最小单位"></el-table-column>
      <el-table-column prop="productTerritory" label="属地"></el-table-column>
      <el-table-column label="是否停产">
        <template slot-scope="scope">
          <span>{{scope.row.isStop === 1?'未停产':'已停产'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="proType" label="产品类型">
        <template slot-scope="scope">{{scope.row.proType === 1?'标准产品':'组合产品'}}</template>
      </el-table-column>
      <el-table-column prop="isTemp" label="状态" v-if="activeName === 'temporaryProduct'">
        <template slot-scope="scope">
          <span>{{scope.row.isTemp|proStatusFilter}}</span>
        </template>
      </el-table-column>
      <el-table-column label="添加人" v-if="activeName === 'temporaryProduct'">
        <template slot-scope="scope">{{scope.row.createUser}}</template>
      </el-table-column>
      <el-table-column label="最后更新时间" width="125px" v-if="activeName !== 'temporaryProduct'">
        <template slot-scope="scope">{{scope.row.editDate|dateFilter}}</template>
      </el-table-column>
      <el-table-column label="添加时间" width="125px" v-if="activeName === 'temporaryProduct'">
        <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" v-if="activeName === 'temporaryProduct'">
        <template slot-scope="scope">
          <span
            v-show="scope.row.approvalState === 0"
            class="approval"
            @click="onProductDetailLook(scope.row)"
          >审批</span>
          <span
            v-show="scope.row.approvalState === 1"
            class="approval"
            @click="onProductDetailLook(scope.row)"
          >查看</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { formatDate } from '@/util/tool'
export default {
  name: 'productTable',
  props: ['online', 'activeName', 'loadingTable'],
  data () {
    return {
      checkList: [],
      tableHeight: window.innerHeight - 470

    }
  },
  watch: {

    online: {
      handler (newVal) {
        newVal.forEach((element) => {
          if (element.productPrice !== null) {
            element.productPrice = parseFloat(element.productPrice).toFixed(2)
          }
        })
        this.$nextTick(() => {
          this.$refs.onlineTableRefs.doLayout()
        })
      },
      deep: true
    }
  },
  created () {
    this.height = document.documentElement.clientHeight
  },
  methods: {
    selectableFun(row) {
      if (this.activeName === 'temporaryProduct') {
        if (row.approvalState === 0) {
          return true
        }
      } else {
        return true
      }
    },
    // 列表数据选中
    handleSelectionChange (row) {
      this.checkList = row
      this.$emit('checkList', this.checkList)
    },
    // 点击空白处选中
    handleRowClick (row, column, event) {
      this.$refs.onlineTableRefs.toggleRowSelection(row)
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 进入产品详情-编辑页
    onProductDetailLook (row) {
      this.$router.push({
        name: 'productDetails',
        query: { id: row.id, approvalState: +row.approvalState },
        params: { activeName: this.activeName }
      })
    },
    // 进入产品详情-编辑页
    onProductDetail (row) {
      this.$router.push({
        name: 'productDetails',
        query: { id: row.id },
        params: { activeName: this.activeName }
      })
    }
  },
  filters: {
    dateFilter,
    proStatusFilter: function (data) {
      if (data === 0) {
        return '待添加'
      } else if (data === 1) {
        return '临时'
      } else if (data === 2) {
        return '正式'
      }
    }
  }
}
function dateFilter (time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
